import React, { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Button } from '../../components/ui/Button'
import { LeftArrowWhite } from '../../assets/images/svg/LeftArrow'
import CheckYourDeviceImg from "../../assets/images/CheckYourDevice.png"
import { toast } from 'react-toastify'
import { sendEmail, sendSms } from 'src/services/functionServices'
import { observer } from 'mobx-react'
import { applicationStore } from 'src/store/ApplicationStore'
import Preloader from 'src/components/ui/Preloader'
import { useTranslation } from 'react-i18next'

const CheckYourDevice = observer(() => {
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const email = location?.state?.value;
  const phoneNumber = location?.state?.phoneValue;
  const { t } = useTranslation();

  const handleResentSecureLink = async () => {
    try {
      setSubmitting(true);
      if (email) {
        await sendEmail(email, applicationStore.access_token)
        toast.success(t('checkYourDevice.emailSent'))
      } else if (phoneNumber) {
        await sendSms(phoneNumber, applicationStore.access_token)
        toast.success(t('checkYourDevice.smsSent'))
      }
    } catch (error) {
      toast.error(email ? t('checkYourDevice.emailNotSent') : t('checkYourDevice.smsNotSent'))
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="custom-container">
      <div className="flex justify-between flex-col items-center h-full">
        <div>
          <div className='text-left'>
            <Button className="" variant="primaryBack" onClick={() => { navigate(applicationStore.previousRoute.continueOnAnotherDeviceSmsOrEmail, { replace: true }) }}><LeftArrowWhite /></Button>
          </div>
          <div className='grid gap-[16px] mt-10'>
            <div className="text-h5 font-bold text-flow-heading">{t('checkYourDevice.title')}</div>
            <div className="text-body text-Gray900">
              <span>{t('checkYourDevice.sentToPrefix')}</span>
              <br />
              <span className='font-bold'>{email ? email : phoneNumber}</span>
              <br />
              <span>{t('checkYourDevice.return')}</span>
            </div>
          </div>
          <div className='mt-4 flex justify-center flex-col items-center'>
            <figure className=''>
              <img alt={t('checkYourDevice.title')} className="w-[313px] h-[313px] rounded-[16px]" src={CheckYourDeviceImg} />
            </figure>
          </div>
          <div className='mt-6 grid gap-2'>
            <Button className="" variant="secondaryWithoutIcon" disabled={submitting} onClick={handleResentSecureLink}>
              <span className="me-1">{t('checkYourDevice.resend')}</span>{submitting && <Preloader variant="black" />}
            </Button>
          </div>
        </div>
        <div className="">

        </div>
      </div>
    </div>
  )
})

export default CheckYourDevice
